<div class="branding-colors-container" [formGroup]="form">
    <div class="align-items-center">
        <!-- PRIMARY -->
        <div formGroupName="primary" class="mb-4">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker
                    id="primary-color-picker"
                    label="Primary color"
                    formControlName="color"
                ></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="primaryColorControl.value" label="Primary"></app-color-palette>
        </div>

        <!-- SECONDARY -->
        <div formGroupName="secondary" class="mb-4">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker label="Secondary color" formControlName="color"></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="secondaryColorControl.value" label="Secondary"></app-color-palette>
        </div>

        <!-- SUCCESS -->
        <div formGroupName="success">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker label="Success color" formControlName="color"></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="successColorControl.value" label="Success"></app-color-palette>
        </div>

        <!-- ERROR -->
        <div formGroupName="error">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker label="Error color" formControlName="color"></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="errorColorControl.value" label="Error"></app-color-palette>
        </div>

        <!-- WARN -->
        <div formGroupName="warn">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker label="Warn color" formControlName="color"></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="warnColorControl.value" label="Warn"></app-color-palette>
        </div>

        <!-- INFO -->
        <div formGroupName="info">
            <div class="d-flex flex-wrap gap-4">
                <app-color-picker label="Info color" formControlName="color"></app-color-picker>
                <app-tone-selector-form formControlName="tones"></app-tone-selector-form>
            </div>
            <app-color-palette [color]="infoColorControl.value" label="Info"></app-color-palette>
        </div>
    </div>
</div>
